import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CampaignDto } from "../../../models/campaign/dto/campaign.dto";
import { CreateCampaignInputDto } from "../../../models/campaign/dto/campaign-input.dto";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_CAMPAIGNS_QUERY_KEY } from "./useListCampaigns";

export const useCreateCampaign = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (input: CreateCampaignInputDto) =>
            client.fetchApi<CampaignDto, CreateCampaignInputDto>({
                endpoint: `campaigns/admin/${selectedOrganization?.id}`,
                method: 'POST',
                body: input,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_CAMPAIGNS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
